import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import "../../../styles/broadcast-system/broadcast-progress.css";

const BroadcastProgressBar = ({
  isVisible,
  onComplete,
  onClose,
  broadcastData,
  onModalClose,
}) => {
  console.log("BroadcastProgressBar - broadcastData:", broadcastData);

  const { postPutLoading } = useSelector((state) => state.common);
  const [progress, setProgress] = useState(0);
  const [status, setStatus] = useState("preparing");
  const [result, setResult] = useState(null);

  const getStatusText = () => {
    switch (status) {
      case "preparing":
        return "Preparing Broadcast";
      case "completed":
        return "Broadcast Completed";
      case "failed":
        return "Broadcast Failed";
      default:
        return "Processing...";
    }
  };

  const getStatusDescription = () => {
    switch (status) {
      case "preparing":
        return "Setting up your broadcast and preparing to send...";
      case "completed":
        return "Your broadcast has been successfully queued and will be sent to all selected recipients.";
      case "failed":
        return "There was an error sending your broadcast. Please check your settings and try again.";
      default:
        return "Processing your broadcast request...";
    }
  };

  useEffect(() => {
    if (isVisible) {
      setProgress(0);
      setStatus("preparing");
      setResult(null);

      setTimeout(() => {
        if (postPutLoading) {
          const progressInterval = setInterval(() => {
            setProgress((prev) => {
              if (prev >= 85) {
                clearInterval(progressInterval);
                return 85;
              }
              return prev + Math.random() * 8 + 2;
            });
          }, 300);

          return () => clearInterval(progressInterval);
        }
      }, 1000);
    }
  }, [isVisible, postPutLoading]);

  useEffect(() => {
    if (!postPutLoading && isVisible && progress > 0) {
      setProgress(100);

      setStatus("completed");
    }
  }, [postPutLoading, isVisible, onComplete, onModalClose, progress]);

  if (!isVisible) return null;

  return (
    <>
      {/* {isVisible && (
        <div className="broadcast-progress-content-wrapper">
          <div className="broadcast-progress-header">
            <h3>Broadcast Progress</h3>
            {status === "completed" && (
              <button
                className="broadcast-progress-close-btn"
                onClick={onModalClose}
                title="Close"
              >
                ✕
              </button>
            )}
          </div> */}

          <div className="broadcast-progress-content">
            <div className="broadcast-progress-status">
              <div className="broadcast-progress-spinner">
                {status === "preparing" && <div className="spinner"></div>}
                {status === "completed" && (
                  <div className="success-icon">✓</div>
                )}
              </div>
              <div className="broadcast-progress-text">
                <h4>{getStatusText()}</h4>
                <p>{getStatusDescription()}</p>
              </div>
            </div>

            <div className="broadcast-progress-bar-container">
              <div className="broadcast-progress-bar">
                <div
                  className="broadcast-progress-fill"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
              <span className="broadcast-progress-percentage">
                {Math.round(progress)}%
              </span>
            </div>

            {status === "completed" && (
              <div className="broadcast-progress-summary">
                <div className="broadcast-summary-details">
                  {/* <p>
                    <strong>Broadcast Name:</strong>{" "}
                    {broadcastData?.broadcastName || "N/A"}
                  </p>
                  <p>
                    <strong>Channels:</strong>{" "}
                    {broadcastData?.isWhatsaap && "WhatsApp "}
                    {broadcastData?.isPush && "Push "}
                    {broadcastData?.isEmail && "Email"}
                  </p> */}
                  <p>
                    <strong>Status:</strong>{" "}
                    <span className="success-text">Successfully Sent</span>
                  </p>
                </div>
              </div>
            )}
          </div>

        {/* </div>
      )} */}
    </>
  );
};

export default BroadcastProgressBar;
